export default {
  showActiveAlarmsOnly: 'Zobraziť iba aktívne alarmy',
};
